/* eslint-disable import/prefer-default-export */
import styled from 'styled-components';
import { motion } from 'framer-motion';
import colours from 'theme/atoms/colours';

export const SuccessPill = styled(motion.div)`
  position: absolute;
  top: 0;
  right: 0;
  align-items: center;
  background-color: ${colours.mint[400]};
  border-radius: 22px;
  display: flex;
  height: 50px;
  padding: 0 15px;
  gap: 8px;
  white-space: nowrap;
  transform-origin: top right;

  p {
    color: black;
  }

  svg {
    color: black;
    flex-shrink: 0;
  }
`;
